import BlankLayout from '@components/Layouts/BlankLayout';
import CBAdminLayout from '@components/Layouts/CBAdminLayout';
import DefaultLayout from '@components/Layouts/DefaultLayout';
import EasyModeLayout from '@components/Layouts/EasyModeLayout';
import ErrorElement from '@pages/ErrorElement.tsx';
import { RoutesArray } from '@router/RoutesArray.tsx';
import { createBrowserRouter } from 'react-router-dom';

const finalRoutes = RoutesArray.map((route) => ({
  ...route,
  element:
    route.layout === 'blank' ? (
      <BlankLayout>{route.element}</BlankLayout>
    ) : route.layout === 'easy-mode' ? (
      <EasyModeLayout>{route.element}</EasyModeLayout>
    ) : route.layout === 'cbadmin' ? (
      <CBAdminLayout>{route.element}</CBAdminLayout>
    ) : (
      <DefaultLayout>{route.element}</DefaultLayout>
    ),
  errorElement: <ErrorElement />,
}));

const Router = createBrowserRouter(finalRoutes);

export default Router;
